import axios from "axios";
import { v4 as uuid } from 'uuid';

export default {
    async postFile(file) {
        let formData = _fileToFormData(file);

        try {
            let response = await _post(formData);
            return response.data;
        } catch (e) {
            window.console.error(e.response.data.message);
            throw e;
        }
    },
    getNewFileForResponse(uploadedFile, file) {
        return {
            id: undefined,
            uuid: uuid().toString(),
            data: {
                ...uploadedFile,
                resource: file
            }
        };
    },
}

const _fileToFormData = (file) => {
    let formData = new FormData();
    formData.append('file', file);
    return formData;
}

const _post = (formData) => {
    return axios.post('/rest/v4/files', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
